import React from 'react';
import { IoChevronDown, IoSearch } from 'react-icons/io5';
import { CATEGORIAS_INICIATIVAS_OFICIAIS } from 'utils/iniciativa-categoria';
import './FiltrosIniciativas.scss';

interface FiltrosIniciativasProps {
  categoriaSelecionada: string;
  onCategoriaChange: (categoria: string) => void;
  termoBusca: string;
  onBuscaChange: (termo: string) => void;
  onBuscar: () => void;
  filtroEtapa1?: string;
  onFiltroEtapa1Change?: (filtro: string) => void;
}

export const FiltrosIniciativas: React.FC<FiltrosIniciativasProps> = ({
  categoriaSelecionada,
  onCategoriaChange,
  termoBusca,
  onBuscaChange,
  onBuscar,
  filtroEtapa1,
  onFiltroEtapa1Change
}) => {

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onBuscar();
    }
  };

  return (
    <div className="filtros-iniciativas" role="search" aria-label="Filtros de iniciativas">
      <div className="filtros-iniciativas__container">

        {filtroEtapa1 !== undefined && onFiltroEtapa1Change && (
          <div className="filtros-iniciativas__dropdown">
            <label htmlFor="filtro-etapa1" className="sr-only">Filtrar por etapa 1</label>
            <div className="filtros-iniciativas__select-wrapper">
              <select
                id="filtro-etapa1"
                className="filtros-iniciativas__select"
                value={filtroEtapa1}
                onChange={(e) => onFiltroEtapa1Change(e.target.value)}
                aria-label="Filtro de classificação na Etapa 1"
              >
                <option value="todas">Todas</option>
                <option value="classificadas">Classificadas Etapa 1</option>
                <option value="nao-classificadas">Não Classificadas</option>
              </select>
              <IoChevronDown className="filtros-iniciativas__select-icon" />
            </div>
          </div>
        )}

        <div className="filtros-iniciativas__busca">
          <label htmlFor="busca-input" className="sr-only">Buscar iniciativas</label>
          <div className="filtros-iniciativas__busca-wrapper">
            <IoSearch className="filtros-iniciativas__busca-icon" size={20} aria-hidden="true" />
            <input
              id="busca-input"
              type="text"
              className="filtros-iniciativas__busca-input"
              placeholder="O que você procura?"
              value={termoBusca}
              onChange={(e) => onBuscaChange(e.target.value)}
              onKeyPress={handleKeyPress}
              aria-label="Buscar iniciativas por título, descrição ou autor"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
